webpackJsonp([59],{

/***/ 1249:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(true);
// imports


// module
exports.push([module.i, ".gnav-links-a:hover{-webkit-transition:all .15s;transition:all .15s}", "", {"version":3,"sources":["/Users/yuki/Public/wp-admin/src/components/navigation/NavigationStandard1/src/components/navigation/NavigationStandard1/NavigationStandard1.l.scss"],"names":[],"mappings":"AAII,oBAEI,4BAA6B,AAC7B,mBAAqB,CACtB","file":"NavigationStandard1.l.scss","sourcesContent":["@import '~scss/variables';\n\n.gnav {\n  &-links {\n    &-a {\n      &:hover {\n        -webkit-transition: all 150ms;\n        transition: all 150ms;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 440:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1249);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(342)("5390ea56", content, true, {});

/***/ })

});


// WEBPACK FOOTER //
// static/js/59.1836e16cd56b670d1ecf.js